<template lang="pug">
  b-row
    .col-md-12.col-lg-12.col-xl-12
      panel(:title='$t("ui.transfer_list")')
        b-card
          b-row.flex(slot="header")
            .col-sm-12.col-md-6.col-lg-6.col-xl-4.mb-1
              b-input-group(:prepend="$t('ui.account_id')" size="sm")
                DebounceInput(
                  type="text"
                  ref="search_id"
                  :placeholder='$t("ui.account_id")'
                  v-model="search_id"
                  size="sm"
                  @keyup.enter.native="submit"
                )
            .col-sm-12.col-md-6.col-lg-6.col-xl-2
              b-input-group(:prepend="$t('ui.status')" size="sm")
                b-form-select(
                  ref="status"
                  v-model="status"
                  :options="$helpers.getStatusList()"
                  size="sm"
                  @change="submit"
                )
            .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
              b-form-checkbox(
                ref="showAll"
                v-model="showAll"
              ) {{ this.$t("message.filter_yesterday_balance") }}
            .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
              b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
            .col-sm-12.col-md-6.col-lg-6.col-xl-2
              SubmitButton(:loading="loading" icon="fa fa-search" :text="$t('ui.search')" isModal=false type="button" @click="submit")
          b-row
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              .alert.alert-warning.mb-1(v-if="isWarning") {{ $t("message.settlement_warning") }}
            .col-sm-12.col-md-8.col-lg-9.col-xl-9.mb-1
              b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="submit")
            .col-sm-12.col-md-4.col-lg-3.col-xl-3.mb-1
              b-input-group(:prepend="$t('ui.page_size')" size="sm")
                b-form-select(:options="[10,20,50,100]" :value="perPage" @input="changedPageSize")
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              b-table#tblList.table-sm.table-hover.table-bordered(striped show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="settlementList" :fields="fields" :per-page="perPage" :filter="filter" @sort-changed="sortingChanged" @head-clicked="clearSelected" :tbody-tr-class="rowClass")
                template(v-slot:head(index)="row")
                  b-form-checkbox(v-model="allSelected" :indeterminate="indeterminate" @change="toggleAll")
                template(v-slot:cell(index)="row")
                  b-form-checkbox(v-model="selected" :value="row.item" @click.stop)
                template(v-slot:cell(account_id)="row")
                  span {{ row.item.account_id.toUpperCase() }}
                template(v-slot:cell(frozen_balance)="row")
                  span(:class="$helpers.getNumberClass(row.item.frozen_balance)") #[b {{ $helpers.settlementFormat(row.item.frozen_balance, 2) }} ]
                template(v-slot:cell(credit_limit)="row")
                  span(:class="$helpers.getNumberClass(row.item.credit_limit)") #[b {{ $helpers.settlementFormat(row.item.credit_limit, 2) }} ]
                template(v-slot:cell(current_balance)="row")
                  span(:class="$helpers.getNumberClass(row.item.current_balance)") #[b {{ $helpers.settlementFormat(row.item.current_balance, 2) }} ]
                template(v-slot:cell(yesterday_balance)="row")
                  span(:class="$helpers.getNumberClass(row.item.yesterday_balance)") #[b {{ $helpers.settlementFormat(row.item.yesterday_balance, 2) }} ]
                template(v-slot:cell(actual_yesterday_balance)="row")
                  span(:class="$helpers.getNumberClass(row.item.actual_yesterday_balance)") #[b {{ $helpers.settlementFormat(row.item.actual_yesterday_balance, 4) }} ]
                template(v-slot:cell(settle_amount)="row")
                  b-form-input.text-right(
                    :ref="'settle_amount' + row.item.account_id"
                    :id="'settle_amount' + row.item.account_id"
                    size="sm"
                    type="text"
                    lazy-formatter=true
                    :value="row.item.actual_yesterday_balance*-1"
                    @keypress="onlyNumber"
                  )
                template(v-slot:cell(action)="row")
                  SubmitButton(:loading="loading" icon="fa fa-money-check" :text="$tc('ui.pay', 1)" isModal=false type="button" size="sm" v-b-modal.settlement @click="singleSettlement(row.item, 'settle_amount' + row.item.account_id)" :disabled="!$helpers.isSuspended() && selected.length > 1" )
                template(v-slot:bottom-row="row" v-if="selected.length > 1")
                  td.text-right(:colspan="bulkPayColspan")
                    SubmitButton(:loading="loading" icon="fa fa-money-check" :text="$tc('ui.pay', 2)" isModal=false type="button" size="sm" v-b-modal.settlementBulk @click="bulkSettlement()" :disabled="$helpers.isSuspended()")

      settlement(:accountID="accID" :yesterdayBalance="ytdBalance" :actualYesterdayBalance="actualYtdBalance" :settleAmount="settleAmount" @clicked="submit")
      settlementBulk(:settleList="bulkList" @clicked="submit")
</template>

<script>
import config from "@/config"
import SubmitButton from "@/library/SubmitButton.vue"
import settlement from "@/components/modal/settlement.vue"
import settlementBulk from "@/components/modal/settlementBulk.vue"
import DebounceInput from "@/library/DebounceInput"

export default {
  components: {
    SubmitButton,
    settlement,
    settlementBulk,
    DebounceInput
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      showAll: true,
      selected: [],
      isWarning: false,
      allSelected: false,
      indeterminate: false,
      search_id: "",
      settlementList: [],
      showTotal: false,
      bulkList: [],
      accID: "",
      ytdBalance: 0,
      actualYtdBalance: 0,
      settleAmount: 0,
      filter: null,
      sortBy: "account_id",
      sortDesc: false,
      currentPage: 1,
      totalRows: 0,
      status: "active"
    };
  },
  validations: {},
  computed: {
    fields() {
      return [
        {
          key: "index",
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "account_id",
          label: this.$t("ui.account_id"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "full_name",
          label: this.$t("ui.full_name"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        ...(this.$store.getters.accountType === 2
          ? [
              {
                key: "frozen_balance",
                label: this.$t("ui.outstanding_balance"),
                sortable: true,
                class: "align-middle text-right",
                thClass: "align-middle text-white bg-dark-lighter",
                thStyle: {
                  width: "10%"
                }
              },
              {
                key: "credit_limit",
                label: this.$t("ui.credit_limit"),
                sortable: true,
                class: "align-middle text-right",
                thClass: "align-middle text-white bg-dark-lighter",
                thStyle: {
                  width: "10%"
                }
              }
            ]
          : []),
        {
          key: "current_balance",
          label: this.$t("ui.current_balance"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "yesterday_balance",
          label: this.$t("ui.yesterday_balance"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "actual_yesterday_balance",
          label: this.$t("ui.actual_yesterday_balance"),
          sortable: true,
          class: "align-middle text-right " + this.show,
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "settle_amount",
          label: this.$t("ui.settle_amount"),
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "action",
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "5%"
          }
        }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    },
    show() {
      return this.$helpers.isAgentLevel() ? "" : "d-none"
    },
    bulkPayColspan() {
      return this.$store.getters.accountType === 2 ? 8 : 10
    }
  },
  watch: {
    selected(newVal, oldVal) {
      // Handle changes in individual flavour checkboxes
      if (newVal.length === 0) {
        this.indeterminate = false
        this.allSelected = false
        this.showTotal = false
      } else if (newVal.length === this.settlementList.length) {
        this.indeterminate = false
        this.allSelected = true
        this.showTotal = true
      } else {
        this.indeterminate = true
        this.allSelected = false
        this.showTotal = false
      }
    }
  },
  mounted: function() {
    this.submit()
  },
  methods: {
    rowClass(item) {
      if (!item) return
      if (
        this.$store.getters.accountType !== 2 &&
        item.frozen_balance > item.credit_limit
      ) {
        return "table-warning"
      }
    },
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 45) { // 46 is dot
          $event.preventDefault();
      }
    },
    toggleAll(checked) {
      this.selected = checked ? this.settlementList : []
      this.showTotal = checked ? true : false
    },
    clearSelected: function() {
      this.allSelected = false;
      this.selected = [];
    },
    singleSettlement: function(account, row) {
      this.accID = account.account_id
      this.ytdBalance = account.yesterday_balance
      this.actualYtdBalance = account.actual_yesterday_balance
      this.settleAmount = document.getElementById(row).value
    },
    bulkSettlement: function() {
      this.bulkList = []
      this.selected.forEach((element, index) => {
        let list = {
          account_id: element.account_id,
          yesterday_balance: element.yesterday_balance,
          actual_yesterday_balance: element.actual_yesterday_balance,
          settle_amount: document.getElementById('settle_amount' + element.account_id).value
        }
        this.bulkList.push(list)
      });
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.submit()
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.submit()
      this.refreshTable("tblList")
    },
    refreshTable(table) {
      this.$root.$emit("bv::table::refresh", table)
    },
    submit: function() {
      this.clearSelected()
      this.settlementList = []
      if (!this.$v.$invalid) {
        let url = (this.$store.getters.accountType == 2) ? config.getSettlementMemberListUrl() : config.getSettlementAgentListUrl()
        let search_id = this.search_id
        let page_number = this.currentPage
        this.currentPage = parseInt(page_number)
        let page_size = this.perPage
        let sort_key = this.sortBy
        let sort_type = this.direction
        let status = this.status
        let show_all = this.showAll ? 0 : 1
        this.loading = true
        this.$store
          .dispatch("user/getSettlementList", { url, search_id, page_number, page_size, sort_key, sort_type, status, show_all })
          .then(response => {
            this.clearTotal()
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
            if (this.submission.success == true) {
              if(response.data.length > 0) {
                this.settlementList = response.data
                if (this.$store.getters.accountType !== 2) {
                  response.data.forEach(x => {
                    if (x.frozen_balance > x.credit_limit) {
                      this.isWarning = true
                      return
                    }
                  })
                }
                this.totalRows = response.data.length > 0 ? this.settlementList[0]["totalrows"] : 0
              } else {
                this.clearTotal()
              }
            } else {
              this.submission.success = response.success
              this.submission.status = response.errorTag
            }
          })
          .catch(response => {
            this.loading = false
            this.clearTotal()
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag)
          });
      }
    },
    clearTotal() {
      this.showTotal = false
      this.settlementList = []
      this.totalRows = 0
    }
  }
};
</script>